import * as React from "react";
import Navbar from "../../../../components/Navbar/Navbar";
import CreateDraftNote from "../../../../components/Notes/CreateNote/CreateDraftNote/CreateDraftNote";

export default function AddNote() {
    const { matches } = window.matchMedia("(max-width: 768px)");

    return (
        <>
            <Navbar showBackIconInNav={matches} title="Create Note" />
            <div className="page">
                <CreateDraftNote />
            </div>
        </>
    );
}
